module.exports = __webpack_public_path__ + "img/world-top-left.7a00dfc2.png";